import { render, staticRenderFns } from "./audio-course.vue?vue&type=template&id=7fdb9bde&scoped=true&"
import script from "./audio-course.vue?vue&type=script&lang=js&"
export * from "./audio-course.vue?vue&type=script&lang=js&"
import style0 from "./audio-course.vue?vue&type=style&index=0&id=7fdb9bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdb9bde",
  null
  
)

export default component.exports